import { Api } from '@axiom/ui';
import type { Candidate, CandidateLegalTechSkill } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateLegalTechSkillsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  readLegalTechSkills(candidateId: Candidate['id']) {
    return super.read<{
      data: CandidateLegalTechSkill[];
    }>({
      endpoint: `/candidates/${candidateId}/legalTechnicalSkills`,
      method: 'GET',
    });
  }

  async updateLegalTechSkills(
    candidateId: Candidate['id'],
    updates: Array<Omit<CandidateLegalTechSkill, 'id'>>
  ) {
    return super.write<boolean>({
      endpoint: `/candidates/${candidateId}/legalTechnicalSkills`,
      body: updates,
      method: 'PUT',
    });
  }

  async deleteLegalTechSkills(
    candidateId: Candidate['id'],
    ids: Array<CandidateLegalTechSkill['id']>
  ) {
    return super.write<boolean>({
      endpoint: `/candidates/${candidateId}/legalTechnicalSkills`,
      body: ids,
      method: 'DELETE',
    });
  }

  async refreshLegalTechSkills(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/legalTechnicalSkills`);
  }
}

export const CandidateLegalTechSkillsApi =
  new CandidateLegalTechSkillsApiClass();
